import FormContainer from "../forms/FormContainer";
import SignupForm from "./SignupForm";


export default function SignupFormContainer() {
    return (
        <FormContainer heading="Sign Up" children={<SignupForm />} />
    )
}